import { Component } from '@angular/core';
import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-quiz-leaderboard',
  templateUrl: './quiz-leaderboard.component.html',
  styleUrls: ['./quiz-leaderboard.component.scss'],
})
export class QuizLeaderboardComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.TriviaPoints;
}
